import { MAIN_OPERATOR } from "@/partial/campaign/constant";
import { CampaignForm } from "@/partial/campaign/types";
import {
  Control,
  useFieldArray,
  UseFormSetValue,
  UseFormWatch,
} from "react-hook-form";
import ConditionForm from "./components/condition-form";
import {
  Flex,
  ReferOutContainer,
  ReferOutTitle,
  ReferOutTitleContainer,
} from "./styles";

interface ReferOutProps {
  indexChannel: number;
  control: Control<CampaignForm>;
  watch: UseFormWatch<CampaignForm>;
  setValue: UseFormSetValue<CampaignForm>;
  mainOperator: string;
}

export const ReferOut = ({
  indexChannel,
  control,
  watch,
  setValue,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  mainOperator,
}: ReferOutProps) => {
  const {
    fields: referOutFields,
    append: appendReferOut,
    remove: removeReferOut,
  } = useFieldArray({
    control,
    name: `campaign_channels[${indexChannel}].refer_out` as `campaign_channels.${number}.refer_out`,
  });

  const handleAddReferOut = (index: number, operator: string) => {
    setValue(
      `campaign_channels.${indexChannel}.refer_out.${index}.current_operator`,
      operator
    );
    appendReferOut({
      when: [],
      condition: [],
      current_operator: MAIN_OPERATOR.OR,
    });
  };

  const handleRemoveReferOut = (index: number) => {
    if (index > 0) {
      setValue(
        `campaign_channels.${indexChannel}.refer_out.${
          index - 1
        }.current_operator`,
        MAIN_OPERATOR.OR
      );
    }
    removeReferOut(index);
  };

  return (
    <ReferOutContainer>
      <ReferOutTitleContainer>
        <ReferOutTitle>Refer Out</ReferOutTitle>
      </ReferOutTitleContainer>
      <Flex>
        {referOutFields.map((field, index) => {
          return (
            <ConditionForm
              key={field.id}
              index={index}
              indexChannel={indexChannel}
              control={control}
              watch={watch}
              setValue={setValue}
              handleAddReferOut={handleAddReferOut}
              handleRemoveReferOut={handleRemoveReferOut}
            />
          );
        })}
      </Flex>
    </ReferOutContainer>
  );
};

export default ReferOut;
